// extracted by css-extract-rspack-plugin
export default {"container":"src-domain-components-system-package-version-definition-step-systemPackageVersionDefinitionStep-module__container-YFdD52"};
    if(module.hot) {
      (function() {
        var localsJsonString = "{\"container\":\"src-domain-components-system-package-version-definition-step-systemPackageVersionDefinitionStep-module__container-YFdD52\"}";
        // 1792611263467
        var cssReload = require("../../../../../node_modules/@rspack/core/dist/cssExtractHmr.js").cssReload(module.id, {});
        // only invalidate when locals change
        if (
          module.hot.data &&
          module.hot.data.value &&
          module.hot.data.value !== localsJsonString
        ) {
          module.hot.invalidate();
        } else {
          module.hot.accept();
        }
        module.hot.dispose(function(data) {
          data.value = localsJsonString;
          cssReload();
        });
      })();
    }
  